import { Tree, TreeItem, TreeItemGroup } from '@angular/aria/tree';
import { NgTemplateOutlet } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  input,
  output,
  signal,
} from '@angular/core';
import { AssetIconPipe } from '../../pipes/asset-icon.pipe';
import { StripPrefixPipe } from '../../pipes/strip-prefix.pipe';
import { TreeNode } from './tree-node.model';

@Component({
  selector: 'lib-tree-view',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    NgTemplateOutlet,
    Tree,
    TreeItem,
    TreeItemGroup,
    AssetIconPipe,
    StripPrefixPipe,
  ],
  templateUrl: './tree-view.component.html',
  styleUrl: './tree-view.component.scss',
})
export class TreeViewComponent {
  readonly dataSource = input.required<TreeNode[]>();
  readonly nodeSelected = output<TreeNode>();
  readonly nodeExpanded = output<TreeNode>();

  private readonly _expanded = signal(new Set<string>());
  readonly selectedValue = signal<string | null>(null);

  isExpanded(value: string): boolean {
    return this._expanded().has(value);
  }

  selectNode(event: Event, node: TreeNode): void {
    event.stopPropagation();
    this.selectedValue.set(node.value);
    this.nodeSelected.emit(node);
  }

  onExpandedChange(expanded: boolean, node: TreeNode): void {
    this._expanded.update((set) => {
      const next = new Set(set);
      expanded ? next.add(node.value) : next.delete(node.value);
      return next;
    });
    if (expanded) {
      this.nodeExpanded.emit(node);
    }
  }
}
